import { motion } from "framer-motion";
import { useState } from "react";
import director from "../assets/images/team/director4.png";
import director3 from "../assets/images/team/director3new.png";
import cofounder from "../assets/images/team/cofounder.JPG";
const directors = [
  {
    name: "Jagmal Singh Yadav",
    title: "Co-Founder",
    image: cofounder,
    desc: `
A visionary leader whose values laid the foundation of trust, discipline,
and long-term thinking within the organization. With decades of experience
and practical wisdom
    `,
    quote:
      "Strong foundations are built on values, patience, and the courage to do things the right way every time.",
  },
  {
    name: "Suresh Yadav",
    title: "Managing-Director",
    image: director3,
    desc: `
Driven by a commitment to operational integrity and scalable growth.
Focused on strengthening systems, empowering teams, and ensuring
that every logistics movement reflects reliability and trust.
    `,
    quote:
      "Strong systems, disciplined execution, and trust are the foundation of sustainable logistics.",
  },
  {
    name: "Lakshay Yadav",
    title: "Director",
    image: director,
    desc: `
Leadership rooted in efficiency, punctuality, and uncompromised quality.
Focused on building reliable logistics systems driven by discipline,
clarity, and long-term partnerships.
    `,
    quote: "Efficiency, punctuality, and quality — delivered consistently.",
  },
  
];

const Team = () => {
  const isMobile = window.innerWidth < 768;
  const [flippedIndex, setFlippedIndex] = useState(null);

  const toggleFlip = (index) => {
    if (!isMobile) return;
    setFlippedIndex(flippedIndex === index ? null : index);
  };

  return (
    <section
      id="team"
      style={{
        position: "relative",
        padding: "160px 40px",
        overflow: "hidden",
        background:
          "linear-gradient(180deg, #ffffff 0%, #f6f9ff 60%,#c7d2fe 70%, #eef4ff 100%)", // added light blue gradient
      }}
    >
      {/* BLUE SPLASH */}
      <motion.div
        animate={{ rotate: [0, 5, 0] }}
        transition={{ duration: 24, repeat: Infinity, ease: "easeInOut" }}
        style={{
          position: "absolute",
          right: "-20%",
          top: "-30%",
          width: "60vw",
          height: "60vw",
          background:
            "radial-gradient(circle at 30% 30%, rgba(37,99,235,0.18), transparent 65%)",
          filter: "blur(70px)",
          borderRadius: "50%",
        }}
      />

      {/* HEADING */}
      <div
        style={{
          textAlign: "center",
          maxWidth: "820px",
          margin: "0 auto 120px",
          position: "relative",
          zIndex: 2,
        }}
      >
        <h2 style={{ fontSize: "48px", marginBottom: "16px", color: "#0b1f2a" }}>
          Leadership
        </h2>
        <p style={{ fontSize: "16px", color: "#425a6b", lineHeight: "1.7" }}>
          Visionary leadership guiding operational excellence, service reliability,
          and nationwide trust.
        </p>
      </div>

      {/* DIRECTORS */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
          gap: "80px",
          justifyItems: "center",
          position: "relative",
          zIndex: 2,
        }}
      >
        {directors.map((person, index) => {
          const isFlipped = flippedIndex === index;

          return (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
              viewport={{ once: true }}
              style={{ perspective: "1400px" }}
              onClick={() => toggleFlip(index)}
            >
              <motion.div
                animate={{
                  rotateY: isMobile
                    ? isFlipped
                      ? 180
                      : 0
                    : undefined,
                }}
                whileHover={!isMobile ? { rotateY: 180 } : {}}
                transition={{ duration: 0.9, ease: "easeInOut" }}
                style={{
                  width: "300px",  // photo card width and size
                  height: "400px",
                  position: "relative",
                  transformStyle: "preserve-3d",
                  cursor: isMobile ? "pointer" : "default",
                }}
              >
                {/* FRONT */}
                <div
                  style={{
                    position: "absolute",
                    inset: 0,
                    backfaceVisibility: "hidden",
                    borderRadius: "22px",
                    overflow: "hidden",
                    background: "#ffffff",
                    boxShadow: "0 40px 90px rgba(37,99,235,0.25)",
                  }}
                >
                  {person.image ? (
                    <img
                      src={person.image}
                      alt={person.name}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        background:
                          "linear-gradient(135deg, #1e3a8a, #2563eb)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "white",
                        fontSize: "64px",
                        fontWeight: 700,
                      }}
                    >
                      {person.name
                        .split(" ")
                        .map((n) => n[0])
                        .join("")}
                    </div>
                  )}

                  <div
                    style={{
                      position: "absolute",
                      bottom: 0,
                      left: 0,
                      right: 0,
                      padding: "24px",
                      background:
                        "linear-gradient(180deg, transparent, rgba(0,0,0,0.75))",
                      color: "white",
                    }}
                  >
                    <h3 style={{ fontSize: "20px", marginBottom: "6px" }}>
                      {person.name}
                    </h3>
                    <p style={{ fontSize: "14px", opacity: 0.85 }}>
                      {person.title}
                    </p>
                  </div>
                </div>

                {/* BACK */}
                <div
                  style={{
                    position: "absolute",
                    inset: 0,
                    transform: "rotateY(180deg)",
                    backfaceVisibility: "hidden",
                    borderRadius: "22px",
                    background:
                      "linear-gradient(180deg, #0b1f2a, #081728)",
                    color: "white",
                    padding: "34px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    boxShadow: "0 40px 90px rgba(0,0,0,0.45)",
                  }}
                >
                  <h3 style={{ fontSize: "22px", marginBottom: "16px" }}>
                    Leadership Philosophy
                  </h3>

                  <p
                    style={{
                      fontSize: "14.5px",
                      lineHeight: "1.8",
                      opacity: 0.9,
                    }}
                  >
                    {person.desc}
                  </p>

                  <p
                    style={{
                      marginTop: "22px",
                      fontSize: "13px",
                      color: "#93c5fd",
                      fontStyle: "italic",
                    }}
                  >
                    “{person.quote}”
                  </p>
                </div>
              </motion.div>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
};

export default Team;





// this below code is for glass view looks 

// import { motion, useScroll, useTransform } from "framer-motion";
// import { useRef } from "react";
// import director from "../assets/images/team/director1.jpeg";

// const Team = () => {
//   const ref = useRef(null);

//   /* 🎥 PARALLAX SCROLL EFFECT */
//   const { scrollYProgress } = useScroll({
//     target: ref,
//     offset: ["start end", "center center"],
//   });

//   const yParallax = useTransform(scrollYProgress, [0, 1], [80, 0]);
//   const opacity = useTransform(scrollYProgress, [0, 0.5], [0, 1]);

//   return (
//     <section
//       ref={ref}
//       id="team"
//       style={{
//         position: "relative",
//         padding: "160px 40px",
//         overflow: "hidden",
//         background:
//           "linear-gradient(180deg, #ffffff 0%, #f6f9ff 60%, #eef4ff 100%)",
//       }}
//     >
//       {/* 🔵 HERO-LIKE BLUE SPLASH (RIGHT SIDE) */}
//       <motion.div
//         style={{
//           position: "absolute",
//           right: "-20%",
//           top: "-30%",
//           width: "60vw",
//           height: "60vw",
//           background:
//             "radial-gradient(circle at 30% 30%, rgba(37,99,235,0.22), transparent 65%)",
//           filter: "blur(70px)",
//           borderRadius: "50%",
//         }}
//         animate={{ rotate: [0, 6, 0] }}
//         transition={{ duration: 22, repeat: Infinity, ease: "easeInOut" }}
//       />

//       {/* 🧠 SECTION HEADING */}
//       <motion.div
//         style={{
//           textAlign: "center",
//           maxWidth: "820px",
//           margin: "0 auto 120px",
//           y: yParallax,
//           opacity,
//         }}
//       >
//         <h2
//           style={{
//             fontSize: "48px",
//             marginBottom: "16px",
//             color: "#0b1f2a",
//             fontWeight: 800,
//           }}
//         >
//           Leadership
//         </h2>

//         <p
//           style={{
//             fontSize: "16px",
//             color: "#425a6b",
//             lineHeight: "1.8",
//           }}
//         >
//           Experienced professionals guiding operations with precision,
//           punctuality, and uncompromised service quality across India.
//         </p>
//       </motion.div>

//       {/* 👤 DIRECTOR CARD */}
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "center",
//           position: "relative",
//           zIndex: 2,
//         }}
//       >
//         <motion.div
//           style={{
//             width: "360px",
//             height: "480px",
//             perspective: "1400px",
//           }}
//           whileHover={{ scale: 1.02 }}
//         >
//           {/* INNER FLIP CONTAINER */}
//           <motion.div
//             whileHover={{ rotateY: 180 }}
//             transition={{ duration: 0.9, ease: "easeInOut" }}
//             style={{
//               width: "100%",
//               height: "100%",
//               position: "relative",
//               transformStyle: "preserve-3d",
//             }}
//           >
//             {/* FRONT SIDE */}
//             <div
//               style={{
//                 position: "absolute",
//                 inset: 0,
//                 backfaceVisibility: "hidden",
//                 borderRadius: "28px",
//                 overflow: "hidden",
//                 background: "#ffffff",
//                 boxShadow: "0 50px 120px rgba(37,99,235,0.25)",
//               }}
//             >
//               <img
//                 src={director}
//                 alt="Charan Singh Yadav"
//                 style={{
//                   width: "100%",
//                   height: "100%",
//                   objectFit: "cover",
//                 }}
//               />

//               {/* 🪪 GLASS NAMEPLATE */}
//               <div
//                 style={{
//                   position: "absolute",
//                   bottom: "26px",
//                   left: "26px",
//                   right: "26px",
//                   padding: "18px 22px",
//                   borderRadius: "18px",
//                   background:
//                     "linear-gradient(180deg, rgba(255,255,255,0.35), rgba(255,255,255,0.15))",
//                   backdropFilter: "blur(16px)",
//                   border: "1px solid rgba(255,255,255,0.35)",
//                 }}
//               >
//                 <h3
//                   style={{
//                     fontSize: "20px",
//                     fontWeight: 700,
//                     color: "#0b1f2a",
//                     marginBottom: "4px",
//                   }}
//                 >
//                   Charan Singh Yadav
//                 </h3>

//                 <p
//                   style={{
//                     fontSize: "13px",
//                     color: "#1d4ed8",
//                     fontWeight: 600,
//                     letterSpacing: "0.4px",
//                   }}
//                 >
//                   Managing Director
//                 </p>
//               </div>
//             </div>

//             {/* BACK SIDE */}
//             <div
//               style={{
//                 position: "absolute",
//                 inset: 0,
//                 transform: "rotateY(180deg)",
//                 backfaceVisibility: "hidden",
//                 borderRadius: "28px",
//                 padding: "40px",
//                 background:
//                   "linear-gradient(180deg, #0b1f2a 0%, #081728 100%)",
//                 color: "white",
//                 boxShadow: "0 50px 120px rgba(0,0,0,0.45)",
//                 display: "flex",
//                 flexDirection: "column",
//                 justifyContent: "center",
//               }}
//             >
//               <h3
//                 style={{
//                   fontSize: "24px",
//                   marginBottom: "18px",
//                 }}
//               >
//                 Leadership Philosophy
//               </h3>

//               <p
//                 style={{
//                   fontSize: "15px",
//                   lineHeight: "1.9",
//                   opacity: 0.9,
//                 }}
//               >
//                 Built on efficiency, punctual execution, and uncompromised
//                 service quality — leadership that prioritizes operational
//                 discipline, trust, and long-term partnerships.
//               </p>

//               <p
//                 style={{
//                   marginTop: "22px",
//                   fontSize: "14px",
//                   color: "#93c5fd",
//                   fontStyle: "italic",
//                 }}
//               >
//                 “Consistency creates credibility.”
//               </p>
//             </div>
//           </motion.div>
//         </motion.div>
//       </div>
//     </section>
//   );
// };

// export default Team;
